
import {
  Mixins,
  Component,
  Watch,
  Prop,
} from 'vue-property-decorator';
import api from '@/api/verify';
import { ITABLECOLCONF } from '@/types/base.d';
import {
  Card,
  Col,
  Button,
  Row,
  Dialog,
  Select,
  Option,
  Form,
  FormItem,
  Input,
  Radio,
  RadioGroup,
  Table,
  TableColumn,
} from 'element-ui';

@Component({
  components: {
    Card,
    Col,
    Button,
    Row,
    Dialog,
    Select,
    Option,
    Form,
    FormItem,
    Input,
    Radio,
    RadioGroup,
    Table,
    TableColumn,
  },
})

export default class verifyModal extends Mixins() {
  @Prop({
    default: false,
    required: true,
  }) show!: boolean;

  @Prop({
    default: false,
    required: true,
  }) worksItem!: any;

  @Prop({
    default: false,
    required: true,
  }) showFlag!: boolean;

  @Prop({
    default: false,
    required: true,
  }) verifyTitle!: string;

  @Prop({
    default: false,
    required: false,
  }) listUserTitle!: string;

  @Prop({
    default: false,
    required: false,
  }) listOrgTitle!: string;

  public $refs!: {
    form: Form,
  };

  private visible: boolean = this.show;

  private list: any = [];

  private auditExplainVali = (rule: any, value: any, callback: Function) => {
    if (this.form.auditResult === 1 && value === '') callback(new Error('未审核描述不能为空'));
    else callback();
  }

  private rules: any = {
    auditResult: [
      { required: true, message: '请输入审核结果', trigger: 'change' },
    ],
    auditExplain: [
      { validator: true, message: '请输入审核结果' },
      { validator: this.auditExplainVali, trigger: 'change' },
    ],
  }

  public form: any = {
    projectPid: '',
    auditResult: null,
    auditExplain: '',
  }

  private verifyList: any = [];

  private options: any = [
    {
      value: 0,
      label: '通过',
    },
    {
      value: 1,
      label: '未通过',
    },
  ]

  public column: Array<any> = [{
    label: '审核时间',
    prop: 'createTime',
    align: 'center',
  },
  {
    label: '审核人',
    prop: 'empName',
    align: 'center',
    tooltip: true,
  },
  {
    label: '审核状态',
    prop: 'auditResult',
    align: 'center',
    custom: true,
    tags: [{
      value: '1',
      type: 'warning',
      label: '未通过',
    }, {
      value: '0',
      type: 'success',
      label: '通过',
    }],
  },
  {
    label: '审核描述',
    align: 'center',
    prop: 'auditExplain',
  }];

  mounted() {
    api.getVerifyList(this.worksItem.projectPid ? this.worksItem.projectPid : this.worksItem.pid).then((res) => {
      this.verifyList = res;
      this.list = this.verifyList;
    });
  }

  /* eslint-disable class-methods-use-this */
  openWorks(id: string, version: number) {
    if (version === 2) {
      window.open(`${process.env.VUE_APP_SCRATCH_2X}${id}`);
    } else {
      window.open(`${process.env.VUE_APP_SCRATCH_3X}${id}`);
    }
  }

  dialogClose() {
    this.$emit('update:show', false);
  }

  verifySubmit() {
    if(this.worksItem.pid) {
      this.form.auditResult = this.form.auditResult * 1
    }
    this.form.projectPid = this.worksItem.projectPid ? this.worksItem.projectPid : this.worksItem.pid;
    this.$refs.form.validateField('auditExplain');
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        api.submitVerify(this.form).then(() => {
          this.$emit('update:show', false);
          this.$emit('eventGetData');
          this.resetForm();
        });
      } else {
        return false;
      }
      return true;
    });
  }

  resetForm() {
    this.$refs.form.resetFields();
  }

  reset() {
    this.resetForm();
  }
}
